var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedJudge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6777 38.5664L31.3652 28.2539",
    stroke: "#20DACD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3639 28.2474L23.9889 35.6224C22.3639 37.2474 19.7181 37.2474 18.0931 35.6224L9.25977 26.789C7.63477 25.164 7.63477 22.5182 9.25977 20.8932L23.9889 6.16406C25.6139 4.53906 28.2598 4.53906 29.8848 6.16406L38.7181 14.9974C40.3431 16.6224 40.3431 19.2682 38.7181 20.8932L31.3639 28.2474Z",
    stroke: "#CB1C68",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18164 43.75H16.6816",
    stroke: "#20DACD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6699 16.5L28.3991 31.2291",
    stroke: "#CB1C68",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedJudge);
export default __webpack_public_path__ + "static/media/red_judge.eeed2ce01910fea9f1289e1f107782ff.svg";
export { ForwardRef as ReactComponent };